module.exports = __webpack_public_path__ + "static/media/2-3.6ebaa083.svg";